import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { regisActions } from '../../../store/actions'
import history from '../../../route/history'
import $ from 'jquery'
import Alert from '../../../module/alert/Alert'

const DuplicateJoinInfo = (props) => {
    const [state, setState] = useState({
        isShowLogin: false, //uth 로그인 정보 입력창
        isType: '', //가입구분
    })

    useEffect(() => {
        $('.join-intro a').on('click', function () {
            $(this).addClass('on').siblings('a').removeClass('on')
        })
    }, [])

    const goNext = () => {
        let type = state.isType
        // console.log('type : ' + type)
        if (type === 'user') {
            //props.setJoinFlag(type)
            setState({ ...state.isShowLogin, isShowLogin: false })
            history.replace({ pathname: '/login' })
        } else if (type === 'corp') {
            //props.setJoinFlag(type)
            setState({ ...state.isShowLogin, isShowLogin: false })
            history.replace({ pathname: '/loginCorp' })
        }
    }

    const cancel = () => {
        setState({ ...state.isShowLogin, isShowLogin: false })

        let join = document.getElementsByClassName('join-user')
        for (let i = 0; i < join.length; i++) {
            join[i].classList.remove('on')
        }
    }

    return (
        <React.Fragment>
            {/* <Alert /> */}
            <div id="contents">
                <div className="content-header type2">
                    {/* mobile 뒤로가기 버튼 */}
                    <a
                        onClick={(e) => {
                            e.preventDefault()
                            window.history.back()
                        }}
                        className="page-prev"
                    >
                        뒤로이동
                    </a>
                    <h2>중복가입 안내</h2>
                    <div className="breadcrumb">
                        <span>Home</span>
                        <em>중복가입 안내</em>
                    </div>
                </div>

                <div className="join-wrap">
                    <div className="join-intro">
                        <button style={{width: 'calc(100% - 12px)'}}>
                            <p className="required"><b> 이미 가입된 기업 담당자가 존재합니다. </b></p>
                            <p className="required"><b> 기업 담당자에게 초대가입 요청을 해주시기 바랍니다. </b></p>
                        </button>
                    </div>
                </div>

            </div>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {}
}

const actionCreators = {
    setJoinFlag: regisActions.setJoinFlag,
}

export default connect(mapStateToProps, actionCreators)(DuplicateJoinInfo)
